var CompanySize = {
	"Company size": "ขนาดของบริษัท",
	"1-19 employees": "พนักงาน 1-19 คน",
	"20-99 employees": "พนักงาน 20-99 คน",
	"100-499 employees": "พนักงาน 100-499 คน",
	"500-999 employees": "พนักงาน 500-999 คน",
	"1,000-9,999 employees": "พนักงาน 1,000-9,999 คน",
	"10,000 employees or more": "พนักงาน 10,000 คนขึ้นไป"
};

export { CompanySize as default };
